<template>
  <div id="app">
    <GlobalLoading />
    <router-view />
  </div>
</template>

<script>

import GlobalLoading from './components/SideEffectLoading.vue'

export default {
  // name: 'App',
  components: {
    GlobalLoading
  },

}
</script>

<style></style>
